function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.3903 6.26552L7.01531 9.64052C6.94495 9.71089 6.84951 9.75042 6.75 9.75042C6.65049 9.75042 6.55505 9.71089 6.48469 9.64052C6.41432 9.57016 6.37479 9.47472 6.37479 9.37521C6.37479 9.2757 6.41432 9.18026 6.48469 9.1099L9.21984 6.37521H1.875C1.77554 6.37521 1.68016 6.3357 1.60984 6.26537C1.53951 6.19505 1.5 6.09966 1.5 6.00021C1.5 5.90075 1.53951 5.80537 1.60984 5.73504C1.68016 5.66472 1.77554 5.62521 1.875 5.62521H9.21984L6.48469 2.89052C6.41432 2.82016 6.37479 2.72472 6.37479 2.62521C6.37479 2.5257 6.41432 2.43026 6.48469 2.3599C6.55505 2.28953 6.65049 2.25 6.75 2.25C6.84951 2.25 6.94495 2.28953 7.01531 2.3599L10.3903 5.7349C10.4252 5.76972 10.4528 5.81108 10.4717 5.85661C10.4906 5.90213 10.5003 5.95093 10.5003 6.00021C10.5003 6.04949 10.4906 6.09829 10.4717 6.14381C10.4528 6.18934 10.4252 6.23069 10.3903 6.26552Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue);
export default __webpack_public_path__ + "static/media/arrow-blue.37787dd05edcf01b21eacc9a3e0d5b9d.svg";
export { ForwardRef as ReactComponent };